import {
  backup,
  builder,
  credentials,
  domains,
  imageOptimizer,
  boosterMain,
  boosterMainDisabled,
  boosterHostingPerformance,
  boosterHostingPerformanceForHosted,
  logs,
  manage,
  mySites,
  main,
  plugins,
  redirects,
  resource,
  restore,
  // security,
  seo,
  seoOverview,
  seoSearch,
  staging,
  themes,
  tools,
  whiteLabel,
  WebsiteSidebarItem,
  stagingEnabled,
  boosterPages,
  boosterImageOptimizer,
  boosterSettings,
  boosterCloudflare,
  referralProgram, boosterPro, boosterWhiteLabel
} from "./website-sidebar-item";

export class WebsiteSidebarSubMenu {
  public name: string;
  public label: string;
  public type: 'static' | 'dropdown' | 'accordion';
  public img?: string;
  public icon?: string;
  public subMenu?: WebsiteSidebarItem[];
  public toggled: boolean;
  public disabled: boolean;
  public hidden: boolean = false;
  public advanced: boolean = false;
  public badge?: string;
  private pageIds?: string[];

  constructor(
    name: string,
    label: string,
    type: 'static' | 'dropdown' | 'accordion',
    img?: string,
    icon?: string,
    subMenu?: WebsiteSidebarItem[],
    pageIds?: string[],
    badge?: string,
    advanced?: boolean,
  ) {
    this.name = name;
    this.label = label;
    this.type = type;
    img && (this.img = img);
    icon && (this.icon = icon);
    subMenu && (this.subMenu = subMenu);
    pageIds && (this.pageIds = pageIds);
    badge && (this.badge = badge);
    advanced && (this.advanced = advanced);
  }

  public toggle(routerLink?: string): void {
    if (routerLink) {
      this.toggled = this.pageIds && this.pageIds.includes(routerLink);
    }
    else {
      this.toggled = !this.toggled;
    }
  }
}

export const booster: WebsiteSidebarSubMenu = new WebsiteSidebarSubMenu('booster', 'text_speedOptimizer', 'static', 'assets/images/menu-icons/website-booster.svg', null,
  [boosterMain, boosterPages, boosterImageOptimizer, boosterCloudflare, boosterHostingPerformance, boosterPro, boosterSettings, boosterWhiteLabel], ['frontend', 'pages', 'image-optimizer', 'cloudflare', 'hosting-performance', 'pro', 'settings', 'white-label']);

export const boosterDev: WebsiteSidebarSubMenu = new WebsiteSidebarSubMenu('boosterDev', 'text_speedOptimizer', 'static', 'assets/images/menu-icons/website-booster.svg', null,
  [boosterMain, boosterPages, boosterImageOptimizer, boosterHostingPerformance, boosterSettings, boosterWhiteLabel], ['frontend', 'pages', 'image-optimizer', 'hosting-performance', 'settings', 'white-label']);

export const boosterDisabled: WebsiteSidebarSubMenu = new WebsiteSidebarSubMenu('booster', 'text_speedOptimizer', 'static', 'assets/images/menu-icons/website-booster.svg', null,
  [boosterMainDisabled, boosterImageOptimizer, boosterCloudflare], ['frontend', 'image-optimizer', 'cloudflare']);

export const boosterDisabledDev: WebsiteSidebarSubMenu = new WebsiteSidebarSubMenu('booster', 'text_speedOptimizer', 'static', 'assets/images/menu-icons/website-booster.svg', null,
  [boosterMain, boosterImageOptimizer], ['frontend', 'image-optimizer']);

export const boosterPaid: WebsiteSidebarSubMenu = new WebsiteSidebarSubMenu('boosterPaid', 'text_speedOptimizer', 'static', 'assets/images/menu-icons/website-booster.svg', null,
  [boosterMain, boosterPages, boosterImageOptimizer, boosterCloudflare, boosterHostingPerformance, boosterSettings, boosterWhiteLabel], ['frontend', 'pages', 'image-optimizer', 'cloudflare', 'hosting-performance', 'settings', 'white-label']);

export const hostingLive: WebsiteSidebarSubMenu = new WebsiteSidebarSubMenu('hosting', 'text_hosting.title', 'accordion', 'assets/images/menu-icons/hosting-icon.svg', null,
  [credentials, domains, tools, redirects, restore, resource, logs, boosterHostingPerformanceForHosted, staging], ['redirects', 'restore', 'hosting-resource-usage', 'logs', 'hosting-performance:', 'environment'], null, true);

export const hostingLiveStagingEnabled: WebsiteSidebarSubMenu = new WebsiteSidebarSubMenu('hosting', 'text_hosting.title', 'accordion', 'assets/images/menu-icons/hosting-icon.svg', null,
  [credentials, domains, tools, redirects, restore, resource, logs, boosterHostingPerformanceForHosted, stagingEnabled], ['redirects', 'restore', 'hosting-resource-usage', 'logs', 'hosting-performance:']);

export const hostingDev: WebsiteSidebarSubMenu = new WebsiteSidebarSubMenu('hosting', 'text_hosting.title', 'accordion', 'assets/images/menu-icons/hosting-icon.svg', null,
  [credentials, domains, tools, redirects, resource, manage, logs], ['redirects', 'restore', 'hosting-resource-usage', 'environment', 'logs']);

export const hostingParentSubFolder: WebsiteSidebarSubMenu = new WebsiteSidebarSubMenu('hosting', 'text_hosting.title', 'accordion', 'assets/images/menu-icons/hosting-icon.svg', null,
  [credentials, domains, tools, redirects, restore, resource, logs], ['restore', 'hosting-resource-usage', 'logs']);

export const hostingParentSubDomain: WebsiteSidebarSubMenu = new WebsiteSidebarSubMenu('hosting', 'text_hosting.title', 'accordion', 'assets/images/menu-icons/hosting-icon.svg', null,
  [credentials, tools, restore, resource, logs], ['restore', 'hosting-resource-usage', 'logs']);

export const hostingChildSubFolder: WebsiteSidebarSubMenu = new WebsiteSidebarSubMenu('hosting', 'text_hosting.title', 'accordion', 'assets/images/menu-icons/hosting-icon.svg', null,
  [redirects]);

export const hostingChildSubDomain: WebsiteSidebarSubMenu = new WebsiteSidebarSubMenu('hosting', 'text_hosting.title', 'accordion', 'assets/images/menu-icons/hosting-icon.svg', null,
  [domains, tools, redirects]);

// export const builderEnabled: WebsiteSidebarSubMenu = new WebsiteSidebarSubMenu('builderEnabled', 'text_ai-builder.title', 'static', 'assets/images/menu-icons/builder.svg', null,
//   [recreate, templates]);

export const seoEnabled: WebsiteSidebarSubMenu = new WebsiteSidebarSubMenu('seoEnabled', 'text_seo', 'dropdown', 'assets/images/menu-icons/seo.svg', null,
  [seoOverview, seoSearch], ['seo-overview', 'search-console', 'search-analytics']);

export const networkParentSubFolder: (WebsiteSidebarItem | WebsiteSidebarSubMenu)[] = [
  mySites,
  main,
  hostingParentSubFolder,
  backup,
  // security
];

export const networkParentSubDomain: (WebsiteSidebarItem | WebsiteSidebarSubMenu)[] = [
  mySites,
  main,
  hostingParentSubDomain,
  backup,
  // security
];

export const networkChildSubFolder: (WebsiteSidebarItem | WebsiteSidebarSubMenu)[] = [
  main,
  builder,
  plugins,
  themes,
  seo,
  imageOptimizer,
  whiteLabel
];

export const networkChildSubDomain: (WebsiteSidebarItem | WebsiteSidebarSubMenu)[] = [
  main,
  builder,
  hostingChildSubDomain,
  plugins,
  themes,
  seo,
  imageOptimizer,
  whiteLabel
];

export const hostedLive: (WebsiteSidebarItem | WebsiteSidebarSubMenu)[] = [
  main,
  builder,
  booster,
  hostingLive,
  plugins,
  themes,
  backup,
  // security,
  seo,
  imageOptimizer,
  whiteLabel
];

export const hostedLiveStagingEnabled: (WebsiteSidebarItem | WebsiteSidebarSubMenu)[] = [
  main,
  builder,
  booster,
  hostingLiveStagingEnabled,
  plugins,
  themes,
  backup,
  // security,
  seo,
  imageOptimizer,
  whiteLabel
];

export const hostedDev: (WebsiteSidebarItem | WebsiteSidebarSubMenu)[] = [
  main,
  builder,
  boosterDev,
  hostingDev,
  plugins,
  themes,
  backup,
  // security,
  seo,
  imageOptimizer,
  whiteLabel
];

export const OneProductOrBundleConnected: (WebsiteSidebarItem | WebsiteSidebarSubMenu)[] = [
  plugins
];

export const OneProductOrBundleConnectedWithBooster: (WebsiteSidebarItem | WebsiteSidebarSubMenu)[] = [
  booster,
  plugins
];
export const BoosterConnected: (WebsiteSidebarItem | WebsiteSidebarSubMenu)[] = [
  booster,
  referralProgram
];

export const BoosterConnectedPaid: WebsiteSidebarSubMenu[] = [
  booster
];
